/**
 * Created by luissalcedo on 4/14/17.
 */
export class Code {

  constructor(

    public $key             : string,
    public restaurantId     : string,
    public code             : string,
    public userId           : string,
    public userEmail        : string,
    public adminUser        : string,
    public createdDateTime  : string,
    public usedDateTime     : string,
    public emailSent        : boolean,
    public restaurant       : string,
    public userRole         : string,
    public userInRecord     : boolean

  ){

  };


  static fromJsonList(array): Code[]{

    return array.map(json => Code.fromJson(json));

  }

    static fromJson({$key,restaurantId,code,userId,userEmail,adminUser,createdDateTime,usedDateTime,emailSent,restaurant,userRole,userInRecord})  : Code {
      return new Code($key,restaurantId,code,userId,userEmail,adminUser,createdDateTime,usedDateTime,emailSent,restaurant,userRole,userInRecord)
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/code.ts